export default __webpack_public_path__ + "static/media/reunion222_w640.c0ba922d.jpg";